import {
    DocumentPreviewProvider,
    DocumentSignModalProvider,
    DossierDocumentSignProvider,
    DossierPrescriberProvider,
    SelectGreffeModal,
    useDefaultContextActions,
    TypeDocumentsProvider,
    DocumentSignModalWrapper,
    CollectionBillingProvider,
} from '@europrocurement/l2d-modules';
import React from 'react';
import { useDumbActionsContext } from '@europrocurement/flexy-components';
import DetailDossierContainer from '../../components/DetailDossierContainer/DetailDossierContainer';

// Some providers are defined in the GlobalDataProvider (B2DLayout)
// ex: currentDossierProvider, UsersProvider; validators...
const DetailDossier: React.FunctionComponent = function () {
    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);

    return (
        <DocumentSignModalProvider>
            <DossierDocumentSignProvider>
                <TypeDocumentsProvider autoload>
                    <CollectionBillingProvider autoload={false}>
                        <DocumentPreviewProvider>
                            <DossierPrescriberProvider>
                                <DetailDossierContainer />
                            </DossierPrescriberProvider>
                            <DocumentSignModalWrapper />
                        </DocumentPreviewProvider>
                    </CollectionBillingProvider>
                </TypeDocumentsProvider>
                <SelectGreffeModal />
            </DossierDocumentSignProvider>
        </DocumentSignModalProvider>
    );
};

export default DetailDossier;
